import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/edit-03.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M15.793 2.79301C17.0119 1.5742 18.9881 1.57421 20.2071 2.79301C21.426 4.01192 21.4259 5.98811 20.2071 7.20707L7.64457 19.7705C7.33239 20.0827 7.06547 20.3588 6.73929 20.5586C6.47096 20.7231 6.17811 20.8435 5.87211 20.917C5.50015 21.0063 5.11631 21 4.67484 21H3.00004C2.44775 21 2.00004 20.5523 2.00004 20V18.3262C2.00004 17.8846 1.99373 17.5 2.08304 17.128C2.15654 16.822 2.278 16.5291 2.44242 16.2608C2.64231 15.9348 2.9184 15.6676 3.2305 15.3555L15.793 2.79301ZM21 19L21.1026 19.0059C21.6066 19.0573 21.9999 19.4825 22 20C22 20.5177 21.6067 20.9438 21.1026 20.9952L21 21H12C11.4478 21 11 20.5523 11 20C11.0002 19.4479 11.4478 19 12 19H21ZM4.00004 19H4.67484C5.21139 19 5.31701 18.9939 5.40531 18.9727C5.50727 18.9482 5.60496 18.9074 5.69437 18.8526C5.77171 18.8051 5.85146 18.7345 6.2305 18.3555L18.793 5.79301C19.2308 5.35509 19.2309 4.64494 18.793 4.20707C18.3551 3.76933 17.6449 3.76931 17.2071 4.20707L4.64457 16.7705C4.26512 17.15 4.19495 17.2292 4.1475 17.3067C4.09283 17.396 4.05186 17.493 4.02738 17.5948C4.00618 17.6831 4.00004 17.7894 4.00004 18.3262V19Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as Edit03Icon };
